import { j as o } from "./jsx-runtime.js";
import { c as r, a as m } from "./Transition.js";
import { ActionButtonTrigger as p } from "./ActionButtonTrigger.js";
import "react";
import "./index2.js";
import "react-dom";
import "./has.js";
import "./index12.js";
import "./index8.js";
import "./index13.js";
import "./index14.js";
import "./index9.js";
import "./index6.js";
import "./kebabCase.js";
import "./index4.js";
import "./index11.js";
import "./useChatbotContext.js";
import "./ChatbotProvider.js";
const n = {
  chat_trigger: r`
    position: fixed;
    bottom: 24px;
    right: 24px;

    @media screen and (min-width: 768px) {
      bottom: 32px;
      right: 24px;
    }
    @media screen and (min-width: 1024px) {
      bottom: 32px;
      right: 49px;
    }
  `
};
function y({
  className: t,
  ...i
}) {
  return /* @__PURE__ */ o.jsx(
    p,
    {
      className: m(n.chat_trigger, t),
      ...i
    }
  );
}
export {
  y as FloatingActionButtonTrigger
};
